function defineClass(score) {
  let valueClass = 'danger';
  if (score > 20) valueClass = 'warning';
  if (score >= 50) valueClass = 'success';
  return valueClass;
}

function defineEmoji(score) {
  let result = '&#128546';
  if (score > 20) result = '&#128530';
  if (score >= 50) result = '&#128522';
  if (score >= 70) result = '&#128513';
  if (score >= 90) result = '&#129321';
  return result;
}

function defineStars(score) {
  let star = '<i class="fas fa-star"></i>';
  let half_star = '<i class="fas fa-star-half-alt"></i>';
  let result = star;
  if (score > 10 && score < 20) result += half_star;
  if (score > 20) result += star;
  if (score >= 30 && score < 50) result += half_star;
  if (score >= 50) result += star;
  if (score >= 60 && score < 70) result += half_star;
  if (score >= 70) result += star;
  if (score >= 80 && score < 90) result += half_star;
  if (score >= 90) result += star;
  return result;
}

function highlightAnswer(answers, find) {
  let found_answer_index = answers.findIndex(function (answer) {
    return answer.id === find;
  });
  if (answers[found_answer_index]) {
    answers[found_answer_index].highlight = true;
  }
  return answers;
}

export default {
  defineClass,
  defineEmoji,
  defineStars,
  highlightAnswer,
};
